


export function getDomain(input) {
    input = Array.isArray(input) ? input[0] : input;
    input = input.replace('www.', '');
    var l = document.createElement("a");
    l.href = input;
    return l.hostname;
}

export function getItemUrl(item) {
    if(item.affURL) {
        return item.affURL;
    }
    if(!item.itemURLs || item.itemURLs === "") {
        return "#";
    }
    if(item.itemURLs.indexOf('amazon.com') !== -1 
        || item.itemURLs.indexOf('amazon.co.uk') !== -1
        || item.itemURLs.indexOf('amazon.de') !== -1
        || item.itemURLs.indexOf('amazon.fr') !== -1
        || item.itemURLs.indexOf('amazon.es') !== -1) {
        return formatAmazonUrl(item.itemURLs);
    } 
    return "http://go.redirectingat.com/?id=86675X1539295&xs=1&url="+encodeURI(item.itemURLs)+"&sref="+encodeURI(window.location.href);
}
export function formatAmazonUrl(linkUrl) {
    linkUrl = decodeURIComponent(linkUrl);
    if(linkUrl.indexOf('christmasli0b-20') === -1) {
        var parts = linkUrl.split("?");
        if(parts.length > 1) {
            var params = JSON.parse('{"' + decodeURI(parts[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
            params.tag = "christmasli0b-20";
            var queryString = Object.keys(params)
                    .map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) })
                    .join('&');
            linkUrl = parts[0] + "?" + queryString;
        } else {
            linkUrl += "?tag=christmasli0b-20"; 
        }
    }
    return linkUrl;
}

export function setCookie(key, val, domain=null) {
    domain = domain ? domain : window.location.host.toString();
    var cookie = [key, '=', val, '; domain=.', domain, '; path=/;'].join('');
    if(domain.indexOf('localhost') >= 0) {
        cookie = [key, '=', val, '; path=/;'].join('');
    }
    document.cookie = cookie;
}
export function getCookie(key) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + key + "=");
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
    return false;
}
export function deleteCookie(key, domain=null) {
    domain = domain ? domain : window.location.host.toString();
    var cookie = [key, '=', '', '; domain=.', domain, '; path=/;'].join('');
    if(domain.indexOf('localhost') >= 0) {
        cookie = [key, '=', '', '; path=/;'].join('');
    }
    document.cookie = cookie;
}
export function formatDateString(dateString) {
    var datetimeParts = dateString.split(" ");
    var dateParts = datetimeParts[0].split("-");
    var timeParts = datetimeParts[1].split(":");
    return dateParts[1] + "/" + dateParts[2] + "/" + dateParts[0].substring(2) + " " + timeParts[0] + ":" + timeParts[1] + " EST";
}